const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Aucun fichier choisi',
    fileName: 'Nom du fichier',
    software_service: 'Service logiciel',
    hardware_product: 'Produit matériel',
    sampleFileNameUs: 'Crédit de marchandise US',
    sampleFileNameAu: 'Crédit de marchandise AU',
    rowNumber: 'Numéro de ligne',
    errorMessage: 'Message'
  }
};

export default merchandiseCredit;
